import { CalendarDays, CreditCard, MapPin, RefreshCcw, UserRound } from "lucide-react";
import { formatEuro } from "@/lib/contractApi";
import { formatContractDate, formatContractPeriod } from "@/lib/contractUser";

const SummaryRow = ({ icon: Icon, label, children }) => (
  <div className="grid grid-cols-[28px_1fr] gap-3 border-b border-slate-100 py-3 last:border-0">
    <Icon className="mt-0.5 h-4 w-4 text-red-700" aria-hidden="true" />
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">{label}</div>
      <div className="mt-1 text-sm font-medium text-slate-900">{children}</div>
    </div>
  </div>
);

const tariffName = (code) => {
  if (code === "community") return "Gemeinschaftstarif";
  if (code === "custom") return "Individueller Tarif";
  return "Einzeltarif";
};

export default function ContractSummary({ contract, party }) {
  const terms = contract.terms || {};
  const migration = contract.migration || {};
  const nextPaymentDue = contract.next_payment_due || migration.next_payment_due;
  const isLegacyMigration = contract.contract_kind === "legacy_migration";
  const organization = contract.organization_snapshot || {};
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7" aria-labelledby="contract-summary-title">
      <div className="mb-3 flex items-center justify-between gap-4">
        <h2 id="contract-summary-title" className="text-xl font-semibold text-slate-950">Deine Vertragsdaten</h2>
        <span className="rounded-full bg-slate-100 px-3 py-1 font-mono text-xs text-slate-600">
          {contract.contract_number}
        </span>
      </div>
      <SummaryRow icon={MapPin} label="Wache und Wachabteilung">
        {organization.wache?.name} · {organization.abteilung?.name}
      </SummaryRow>
      <SummaryRow icon={UserRound} label="Vertragspartner">
        {party.name || "Bitte Namen eintragen"}
      </SummaryRow>
      <SummaryRow icon={CreditCard} label="Tarif und Gesamtpreis">
        {tariffName(terms.tariff_code)} · {formatEuro(terms.price_cents)} im Voraus
      </SummaryRow>
      {isLegacyMigration ? <>
        <SummaryRow icon={CalendarDays} label="Vertragsbeginn">
          Vertrag beginnt mit deiner Bestätigung
        </SummaryRow>
        <SummaryRow icon={CalendarDays} label="Übernommener Bestandszeitraum">
          {migration.paid_until
            ? <>Bereits bezahlt bis {formatContractDate(migration.paid_until)}</>
            : <>Noch kein bezahlter Zeitraum – erste Zahlung am {formatContractDate(nextPaymentDue)}</>}
        </SummaryRow>
        <SummaryRow icon={RefreshCcw} label="Nächster Zahlungstermin">
          Nächste Zahlung am {formatContractDate(nextPaymentDue)}
        </SummaryRow>
      </> : <SummaryRow icon={CalendarDays} label="Nutzungszeitraum">
        {formatContractPeriod(terms.period_start, terms.period_end)} · {terms.duration_months} Monate
      </SummaryRow>}
      <SummaryRow icon={RefreshCcw} label="Fortsetzung">
        Keine automatische Abbuchung. Bei unveränderten Bedingungen genügt eine neue Zahlung.
      </SummaryRow>
    </section>
  );
}
